import { toast } from "sonner";
import { api } from "@/lib/api";
import { FormBody, PageHead, useApi } from "@/components/shop/common";

const FIELDS = [
  { name: "shop_name", label: "Shop name", required: true },
  { name: "phone", label: "Phone", half: true },
  { name: "address", label: "Address", half: true },
  { name: "labor_rate", label: "Default labor rate / hr", type: "number", half: true },
  { name: "parts_markup", label: "Parts markup %", type: "number", half: true },
  { name: "tax_rate", label: "Tax on parts %", type: "number", half: true },
];

export default function Settings() {
  const [s, load] = useApi("/settings");
  return (
    <>
      <PageHead eyebrow="Shop" title="Settings" />
      {s && (
        <div className="max-w-lg bg-card border border-border rounded-sm p-6" data-testid="settings-form">
          <FormBody fields={FIELDS} initial={s} testid="settings"
            onSubmit={async (v) => { await api.put("/settings", v); toast.success("Settings saved"); load(); }} />
        </div>
      )}
    </>
  );
}
